import { IWidget } from "@/types/dashboard.types";

export function getHiddenWidgetIds(dashboard: any, widgets: IWidget[]): string[] {
  const hiddenFromGroups = new Set<string>();
  const hiddenFromLayout = new Set<string>((dashboard?.layout?.hiddenWidgetIds || []) as string[]);

  // Collect all widget IDs that are children of any group
  for (const widget of widgets) {
    if (widget.visualizationType === "group" && widget.config?.group?.childrenIds) {
      for (const childId of widget.config.group.childrenIds) {
        hiddenFromGroups.add(childId);
      }
    }
  }

  // Union of group children and explicitly hidden widgets
  return Array.from(new Set([...hiddenFromGroups, ...hiddenFromLayout]));
}
